import { useEffect } from "react";
import { shortcutManager } from "./shortcutManager";

export default function ShortcutProvider({ children }) {
  useEffect(() => {
    shortcutManager.attach();
    return () => {
      shortcutManager.detach();
    };
  }, []);

  return children;
}
